import { all, takeEvery } from "redux-saga/effects";

import { playerActionConstants } from "@/store/actions";
import { fetchAndStoreWaveformsDictionary } from "@/shared/store/saga-functions";

function* fetchWaveformsDictionary(action) {
  const { url, chapterId } = action.data;
  yield fetchAndStoreWaveformsDictionary(url, chapterId);
}

export default function* playerSaga() {
  yield all([
    takeEvery(playerActionConstants.FETCH_WAVE_FORMS_DICTIONARY, fetchWaveformsDictionary),
  ]);
}
